export default function AccountablesGuaranteesExplanation() {
  return (
    <details>
      <summary className="text-lg mb-4">
        Accountables and Guarantees Explainer
      </summary>
      <p className="mb-4">
        <em>Accountables</em> are the amount of your budget that went toward
        each proposal. However, the more important things is the{" "}
        <em>guarantees</em>, i.e. the amount that an org is getting because of
        your MVFs. If you're thinking about which orgs you think should receive
        more or less funding, it's the guarantees that matter.
      </p>
      <p className="mb-4">
        One way to think about this is that two recommenders can share the cost
        of an organization that they both like. If Robby and Rebecca both like
        Argentina, they can fund it together (guaranteeing a higher amount with
        the same accountables), compared to Robby's funding of Bolivia, and only
        Rebecca's funding of Chile.
      </p>
      <table className="border border-stone-300 dark:border-stone-700 mt-4 mb-10">
        <thead className="light:bg-white dark:bg-stone-950 border-b border-stone-300 dark:border-stone-700">
          <tr>
            <th />
            <th className="px-2 py-1" colSpan={2}>
              Robby
            </th>
            <th className="px-2 py-1" colSpan={2}>
              Rebecca
            </th>
          </tr>
          <tr>
            <th className="px-2 py-1">Proposal</th>
            <th className="px-2 py-1">Accountables</th>
            <th className="px-2 py-1">Guarantees</th>
            <th className="px-2 py-1">Accountables</th>
            <th className="px-2 py-1">Guarantees</th>
          </tr>
        </thead>
        <tbody className="light:bg-stone-50 dark:bg-stone-900">
          <tr>
            <th className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              Argentina
            </th>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              50
            </td>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              100
            </td>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              50
            </td>
            <td className="px-2 py-1">100</td>
          </tr>
          <tr>
            <th className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              Bolivia
            </th>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              50
            </td>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              50
            </td>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              0
            </td>
            <td className="px-2 py-1">0</td>
          </tr>
          <tr>
            <th className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              Chile
            </th>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              0
            </td>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              0
            </td>
            <td className="px-2 py-1 border-r light:border-stone-300 dark:border-stone-700">
              50
            </td>
            <td className="px-2 py-1">50</td>
          </tr>
        </tbody>
      </table>
    </details>
  );
}
